export default __webpack_public_path__ + "static/media/background-8.37f95e3c.jpg";